import * as React from 'react'

import { Instrument } from '../../../../main/types'
import TilesStore from '../../../futures/stores/tilesStore'
import { forexDomains, generateColorScale } from '../../../futures/utils'
import ForexCryptoTile from '../../../shared/components/ForexCryptoTile'
import { redGreenGradient } from '../../../shared/gradients'
import * as hoverChart from '../../../shared/hover-chart'

interface TileProps {
  ticker: string
  hoverOffsetX: number
  hoverOffsetY: number
}

const getTileState = (ticker: string) => {
  var tile = TilesStore.getTile(ticker)

  return {
    ...tile,
  }
}

const colorScale = generateColorScale(forexDomains, 'd', redGreenGradient)

export default class Tile extends React.Component<TileProps> {
  state = getTileState(this.props.ticker)

  componentDidMount() {
    TilesStore.addChangeListener(this._onChange)
  }

  componentWillUnmount() {
    TilesStore.removeChangeListener(this._onChange)
  }

  _onChange = () => {
    this.setState(getTileState(this.props.ticker))
  }

  render() {
    const { label, last, prevClose, change, high, low, sparkline, sparklineDateChanges } = this.state
    const { ticker, hoverOffsetX, hoverOffsetY } = this.props

    const format = (n: number) => (n >= 0 ? '+' : '') + n.toFixed(2) + '%'
    const places = last > 6 ? 2 : 4
    const round = (n: number) => (+(Math.round(Number(n + 'e+' + places)) + 'e-' + places)).toFixed(places)

    const range = (high - low) * 0.1
    const highlightHigh = last > high - range
    const highlightLow = last < low + range

    const instrument = ticker.length === 6 ? Instrument.Forex : Instrument.Futures
    const link =
      instrument === Instrument.Forex ? '/forex_charts.ashx?p=d1&t=' + ticker : '/futures_charts.ashx?p=d1&t=' + ticker

    const chartImage = hoverChart.getHoverChartImg(
      '@' + ticker.toLowerCase(),
      false,
      Instrument.Forex ? FinvizSettings.hoverCharts?.forex?.timeframe : FinvizSettings.hoverCharts?.futures?.timeframe,
      Instrument.Forex ? FinvizSettings.hoverCharts?.forex?.dateRange : FinvizSettings.hoverCharts?.futures?.dateRange
    )

    const boxover = `cssbody=[hoverchart] cssheader=[tabchrthdr] body=[${chartImage.img}] offsetx=[${hoverOffsetX}] offsety=[${hoverOffsetY}] delay=[100]`

    return (
      <ForexCryptoTile
        className="m-px"
        label={label}
        boxover={boxover}
        link={link}
        backgroundColor={colorScale(change)}
        extraMargin={ticker.length !== 6 || ticker === 'BTCUSD'}
        last={round(last)}
        change={format(change)}
        lastChange={round(last - prevClose).replace('-', '')}
        low={round(low)}
        high={round(high)}
        highlightLow={highlightLow}
        highlightHigh={highlightHigh}
        sparkline={sparkline}
        sparklineChange={change}
        sparklineDateChanges={sparklineDateChanges}
      />
    )
  }
}
